export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-collection/src/keys.js
// module id = 353
// module chunks = 0